import { Card, Typography } from '@mui/material';
import React from 'react'

const LeaveQuotaCardComponent = (props) => {

    const { leave } = props;

    return (
        <Card variant="outlined" style={{ display: 'inline-flex', flexDirection: 'column', alignItems: 'center', minWidth: '120px', width: '30%', margin: '0px 10px 10px 10px', padding: '15px' }}>
            <div style={{ textAlign: 'center' }}>
                <strong>{leave?.label?.label}</strong>
            </div>
            <div style={{ backgroundColor: leave?.label?.color, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: '100px', height: '50px', borderRadius: '10%' }}>
                <Typography align="center" variant="h6" component="div">
                    {leave.noOfDays}
                </Typography>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                <Typography align="center" variant="subtitle1">
                    No. of Days
                </Typography>
            </div>

        </Card>
    )
}

export default LeaveQuotaCardComponent